import { formatNumber, getRatePrecision } from 'utils/format-number'
import dayjs from 'dayjs'
import { MarketBrief, MarketBriefDayExchange, MarketBriefLastExchange } from 'models/market'
import { getLangFromUrl } from 'utils/current-language'

declare let SINGLE_RATE_BASE_CURRENCY: string

type DataTableSort = 'exchange' | 'volume'

type PayloadPairData = MarketBriefDayExchange[] | MarketBriefLastExchange[]

const cleanupTableContent = (type: DataTableSort): void => {
  const $tableElementsToDrop = document.querySelectorAll<HTMLTableElement>(`[data-last-trades='${type}'] tbody tr`)

  $tableElementsToDrop.forEach((singleItem) => {
    singleItem.parentNode.removeChild(singleItem)
  })
}

const updateVolumeTables = (
  type: DataTableSort,
  rawData: PayloadPairData,
  baseCurrency: string,
  pair: string,
): void => {
  cleanupTableContent(type)

  const tableParent: HTMLTableElement = document.querySelector(`[data-last-trades='${type}'] tbody`)
  const pageLang = getLangFromUrl()

  rawData.reverse()

  const isExchangeType: boolean = type === 'exchange'

  rawData.forEach((singleRow) => {
    const newRow = document.createElement('tr')

    const newTableCellDate: HTMLTableCellElement = document.createElement('td')
    newTableCellDate.classList.add('data-table__table-row-cell', 'is-since')
    newTableCellDate.textContent = isExchangeType
      ? dayjs(singleRow.ts)
          .locale(pageLang === 'pl' ? 'pl' : 'en')
          .fromNow()
      : dayjs(singleRow.day).format('YYYY-MM-DD')

    const newTableCellVolume: HTMLTableCellElement = document.createElement('td')
    newTableCellVolume.classList.add('data-table__table-row-cell', `${isExchangeType ? 'is-rate' : 'is-turnover'}`)
    newTableCellVolume.textContent = isExchangeType
      ? `${formatNumber(singleRow.price, getRatePrecision(pair))}`
      : `${formatNumber(singleRow.volume, 2)} ${baseCurrency}`

    let newTableCellRate: HTMLTableCellElement = null
    if (isExchangeType) {
      newTableCellRate = document.createElement('td')
      newTableCellRate.classList.add('data-table__table-row-cell', 'is-turnover')
      newTableCellRate.textContent = `${formatNumber(singleRow.volume, 2)} ${baseCurrency}`
    }

    newRow.appendChild(newTableCellDate)
    newRow.appendChild(newTableCellVolume)
    isExchangeType ? newRow.appendChild(newTableCellRate) : ''

    tableParent.prepend(newRow)
  })
}

export function handleLastExchanges(payload: MarketBrief): void {
  const pairData: MarketBrief = payload
  if (payload) {
    updateVolumeTables('volume', pairData.dayExchanges, SINGLE_RATE_BASE_CURRENCY, payload.pair)
    updateVolumeTables('exchange', pairData.lastExchanges, SINGLE_RATE_BASE_CURRENCY, payload.pair)
  }
}
